import { render } from "./HeaderMobileHome.vue?vue&type=template&id=60cfa0ff"
import script from "./HeaderMobileHome.vue?vue&type=script&lang=js"
export * from "./HeaderMobileHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__